<template>
  <div>
    <Toolbar
      :handle-submit="onSendForm"
      :handle-reset="resetForm"
      :handle-delete="del"
      >
        <template slot="left">
          <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
            <h1><v-icon large>mdi-format-color-fill</v-icon>{{ item['name'] }}</h1>
          </v-toolbar-title>
        </template>
    </Toolbar>
    <MaterialMediumForm
      ref="updateForm"
      v-if="item"
      :values="item"
      :errors="violations"
    />
    <Loading :visible="isLoading || deleteLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import MaterialMediumForm from '../../components/materialmedium/Form.vue';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import UpdateMixin from '../../mixins/UpdateMixin';

const servicePrefix = 'MaterialMedium';

export default {
  name: 'MaterialMediumUpdate',
  servicePrefix,
  mixins: [UpdateMixin],
  components: {
    Loading,
    Toolbar,
    MaterialMediumForm
  },

  computed: {
    ...mapFields('materialmedium', {
      deleteLoading: 'isLoading',
      isLoading: 'isLoading',
      error: 'error',
      updated: 'updated',
      violations: 'violations'
    }),
    ...mapGetters('materialmedium', ['find'])

  },

  methods: {
    ...mapActions('materialmedium', {
      deleteItem: 'del',
      retrieve: 'load',
      update: 'update',
    })
  }
};
</script>
